import { differenceInMinutes } from 'date-fns'
import { stepIteration } from './stepIteration'

export function minutesToHM(minutes = 0, hours = 0) {
  return {
    h: Math.trunc(minutes / 60) + hours,
    m: minutes % 60,
  }
}

export function hmToTMinutes(minutes: string | number = 0, hours: string | number = 0) {
  return (+hours || 0) * 60 + (+minutes || 0)
}

export function dateToMinutes(date: Date) {
  if (date) {
    // Конец дня
    const seconds = date.getSeconds() === 59 ? 1 : 0
    return hmToTMinutes(date.getMinutes() + seconds, date.getHours())
  }
  return 0
}

// Время ставим по часам, в день перевода часов в поясе браузера в сутках 23 или 25 часов
export function minutesToDate(day: Date, minutes: number) {
  const date = new Date(day)
  date.setHours(0, minutes)
  return date
}

function addZero(v: number): string {
  return v < 10 ? `0${v}` : `${v}`
}

export function formatMinutes(minutes: number) {
  const { h, m } = minutesToHM(minutes)
  return `${addZero(h)}:${addZero(m)}`
}

export function getTimeOptions(start = 0, end = 1440, step = 15) {
  return stepIteration(start, end, step, value => ({ value, label: formatMinutes(value) }))
}

export { differenceInMinutes as durationDifference }
